<template>
  <div>

    <!-- 標題 bar -->
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">生肖走势</span>
        </div>
      </div>
    </div>

    <RadioButtons v-model="select" title="筛选球位" :buttons="filterData" />

    <div v-loading="isLoading" class="ShengXiaoZouShi">
      <v-chart ref="polar" :options="line" />
    </div>

  </div>
</template>

<script>
import RadioButtons from '@/components/desktop/common/RadioButtons'
import { getTrand } from '@/api/desktop/trend'

export default {
  name: 'ShengXiaoZouShi',
  components: {
    RadioButtons
  },
  data() {
    return {
      isLoading: false,
      data: {},
      filterData: [
        { name: '正码一', val: 1 },
        { name: '正码二', val: 2 },
        { name: '正码三', val: 3 },
        { name: '正码四', val: 4 },
        { name: '正码五', val: 5 },
        { name: '正码六', val: 6 },
        { name: '特码', val: 7 }
      ],
      shengXiaoMapping: [
        'shengXiao_shu', // 鼠
        'shengXiao_niou', // 牛
        'shengXiao_hu', // 虎
        'shengXiao_tu', // 兔
        'shengXiao_long', // 龙
        'shengXiao_she', // 蛇
        'shengXiao_ma', // 马
        'shengXiao_yang', // 羊
        'shengXiao_hou', // 猴
        'shengXiao_ji', // 鸡
        'shengXiao_gou', // 狗
        'shengXiao_jhu' // 猪
      ], // 十二生肖分組對應
      chineseMapping: [
        '鼠',
        '牛',
        '虎',
        '兔',
        '龙',
        '蛇',
        '马',
        '羊',
        '猴',
        '鸡',
        '狗',
        '猪'
      ],
      line: {
        backgroundColor: '#fff',
        color: ['#37A2DA'],
        tooltip: {
          trigger: 'axis',
          formatter: (val) => {
            return `<p> ${val[0].axisValue}</p><p>${val[0].marker} ${val[0].seriesName}: ${this.chineseMapping[val[0].value - 1]}</p>`
          }
        },
        legend: {
          show: false,
          x: 'left',
          selected: {
            '正码一': true,
            '正码二': false,
            '正码三': false,
            '正码四': false,
            '正码五': false,
            '正码六': false,
            '特码': false
          }
        },
        xAxis: {
          type: 'category',
          data: [],
          nameLocation: 'middle',
          name: '期号',
          nameTextStyle: {
            fontSize: 24,
            padding: 12,
            height: 4
          },
          axisLabel: {
            interval: 0,
            margin: 8
          }
        },
        yAxis: {
          type: 'value',
          maxInterval: 1,
          axisLabel: {
            interval: 1,
            formatter: (value) => {
              switch (value) {
                case 1:
                  return '鼠'
                case 2:
                  return '牛'
                case 3:
                  return '虎'
                case 4:
                  return '兔'
                case 5:
                  return '龙'
                case 6:
                  return '蛇'
                case 7:
                  return '马'
                case 8:
                  return '羊'
                case 9:
                  return '猴'
                case 10:
                  return '鸡'
                case 11:
                  return '狗'
                case 12:
                  return '猪'
                default:
                  return ''
              }
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          nameRotate: 0,
          nameLocation: 'middle',
          name: '{x|生\n肖\n}',
          nameTextStyle: {
            rich: {
              x: {
                fontSize: 24,
                padding: 12,
                color: 'black',
                height: 4
              }
            }
          }
        },
        series: [
          {
            name: '正码一',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: false,
            data: []
          },
          {
            name: '正码二',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: false,
            data: []
          },
          {
            name: '正码三',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: false,
            data: []
          },
          {
            name: '正码四',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: false,
            data: []
          },
          {
            name: '正码五',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: false,
            data: []
          },
          {
            name: '正码六',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: false,
            data: []
          },
          {
            name: '特码',
            type: 'line',
            symbolSize: 8,
            symbol: 'circle',
            smooth: false,
            data: []
          }
        ]
      },
      select: 1
    }
  },
  watch: {
    select() {
      this.pickNum(this.select)
    }
  },
  mounted() {
    this.getTrand(this.$route.params.lottery_code, { count: 30 })
    window.addEventListener('resize', this.echartResize, false)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.echartResize, false)
    })
  },
  methods: {
    async getTrand(code, query) {
      this.isLoading = true
      const [data, error] = await getTrand(code, query)
      this.isLoading = false
      if (error) {
        console.error(error)
        return
      }
      this.data = data
      this.line.xAxis.data = data.map(el => el.period.length === 10 ? el.period.substr(el.period.length - 4, 4) : el.period.substr(el.period.length - 3, 3))
      data.forEach(per => {
        per.shengXiao.forEach((ball, ballIndex) => {
          this.line.series[ballIndex].data.push(this.shengXiaoMapping.indexOf(ball) + 1)
        })
      })
    },
    echartResize() {
      this.$refs.polar.resize()
    },
    pickNum(value) {
      const chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      for (let i = 1; i < 7; i++) {
        this.line.legend.selected[`正码${chnNumChar[i]}`] = false
        if (i === value) {
          this.line.legend.selected[`特码`] = false
          this.line.legend.selected[`正码${chnNumChar[value]}`] = true
        }
      }
      if (value === 7) {
        this.line.legend.selected[`特码`] = true
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.echarts {
  width: 100%;
  height: 80%;
}
.ShengXiaoZouShi {
  background-color: white;
  width: 100%;
  height: 500px;
}
</style>

